/**
 * FormRadioGroup/FormSelect are string-based (native radio/select inputs always emit strings), but
 * the fact-find schema stores these fields as real booleans. These convert at the UI boundary so a
 * boolean factFind field can still be rendered/edited as a Yes/No control.
 */

/** Boolean (or undefined) -> 'yes' | 'no', for passing into a Yes/No control's `value` prop. */
export function toYesNo(value: unknown): 'yes' | 'no' {
    return value ? 'yes' : 'no';
}

/** 'yes' | 'no' -> boolean, for a Yes/No control's `onChange` handler. */
export function fromYesNo(value: unknown): boolean {
    return value === 'yes';
}

/**
 * Tri-state variant for fields where "not yet answered" is a real, distinct state (e.g. a
 * dropdown with a blank "Select..." option) rather than defaulting to No. Boolean (or
 * undefined) -> '' | 'yes' | 'no', for passing into a tri-state control's `value` prop.
 */
export function toTriYesNo(value: unknown): '' | 'yes' | 'no' {
    if (value === true) return 'yes';
    if (value === false) return 'no';
    return '';
}

/** '' | 'yes' | 'no' -> boolean | undefined, for a tri-state control's `onChange` handler. */
export function fromTriYesNo(value: unknown): boolean | undefined {
    if (value === 'yes') return true;
    if (value === 'no') return false;
    return undefined;
}
